import { endOfDay, isValid, parse, startOfDay } from "date-fns";

export type PayoutDateRangeValue = {
  startDate: Date;
  endDate: Date;
  key: string;
};

export const normalizePayoutDateRange = (
  range: PayoutDateRangeValue,
): PayoutDateRangeValue => ({
  ...range,
  startDate: startOfDay(range.startDate),
  endDate: endOfDay(range.endDate),
});

export const formatPayoutFilterDate = (date: Date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatPayoutDateRangeLabel = (
  range: PayoutDateRangeValue | null,
) =>
  range
    ? `${formatPayoutFilterDate(range.startDate)} - ${formatPayoutFilterDate(
        range.endDate,
      )}`
    : "Date (all)";

export const parsePayoutTableDate = (value: string) => {
  const trimmedValue = value.trim();

  if (!trimmedValue || trimmedValue === "-") {
    return null;
  }

  const formats = [
    "dd MMM yyyy, hh:mm a 'IST'",
    "dd MMM yyyy, h:mm a 'IST'",
    "dd MMM yyyy, hh:mm a",
    "dd MMM yyyy, h:mm a",
    "dd MMM yyyy",
  ];

  for (const format of formats) {
    const parsedDate = parse(trimmedValue, format, new Date());
    if (isValid(parsedDate)) {
      return parsedDate;
    }
  }

  const fallbackDate = new Date(trimmedValue);
  return isValid(fallbackDate) ? fallbackDate : null;
};
